import { render } from "./AdministrativeData.vue?vue&type=template&id=56775606&scoped=true&ts=true"
import script from "./AdministrativeData.vue?vue&type=script&lang=ts"
export * from "./AdministrativeData.vue?vue&type=script&lang=ts"

import "./AdministrativeData.vue?vue&type=style&index=0&id=56775606&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56775606"]])

export default __exports__